
import styles from "./PartSurveyReport.module.scss";
import { useEffect, useState } from "react";
import PartSurveyItemReport from './PartSurveyItemReport/PartSurveyItemReport';
import SurveyChangeForm from "components/Forms/SurveyForm/SurveyChangeForm";
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
const PartSurveyReport = ({ title_dat, id, setRender, partSurveySurveys }) => {
 const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
  const [edit_id, setEditId] = useState(null);

  const ChangeRowOn = (id) => {
    setEditId(id);
  }
  
  return (
    <>
    <button className={styles.btn_print} onClick={handlePrint}>Печать 🖨️ </button>
    <div ref={componentRef}  className={styles.test_card}>
    <div className={styles.div_print}><h4>Отчет по анкете: {title_dat} </h4><h4>Дата отчета: {new Date().toLocaleString("ru-RU")}</h4> </div>
      {partSurveySurveys.map((item, index) =>
        item.id !== edit_id ? (
          <>
          <PartSurveyItemReport
            item={item}
            index={index}
            setRender={setRender}
            MassLength={partSurveySurveys.length}
            ChangeRowOn={ChangeRowOn}
          />
        
          </>
        ) : (
         <></>
          
        )
      )}


    </div >
</>
  );
};

export default PartSurveyReport;
